import { useEffect, useState, type ReactElement } from 'react';

import { BaseBlock } from '@/components/base-block';
import type { HtmlBlockType } from '@/lib/types';

const MeiliBlock = (): ReactElement | null => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const script = document.createElement('script');
    script.src = 'https://direct-ux.meili.travel/index.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <BaseBlock className="html-block" width="Normal">
      <div id="mli-root" className="mli-loading" data-ptid="147.11"></div>
    </BaseBlock>
  );
};

const HtmlBlock = ({ html }: HtmlBlockType): ReactElement => {
  // we need to handle the Meili block somewhat differently
  const isCarHire = html.includes('meili');

  if (isCarHire) {
    return <MeiliBlock />;
  }

  return (
    <BaseBlock className="html-block" width="Normal">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </BaseBlock>
  );
};

export { HtmlBlock };
